import React from 'react';
import { createRoute, redirect } from '@tanstack/react-router';
import { useAuth0 } from '@auth0/auth0-react';
import { Route as rootRoute } from './__root';
import { Layout } from '@/client/layouts/layout';
import { Card, CardContent, CardHeader, CardTitle } from '@/client/components/ui/card';
import { CheckCircle, XCircle } from 'lucide-react';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/profile',
  beforeLoad: async ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/',
      });
    }
  },
  component: ProfileComponent,
});

function ProfileComponent() {
  const { user } = useAuth0();

  return (
    <Layout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">Profile</h1>

        <Card>
          <CardHeader>
            <div className="flex items-center gap-4">
              {user?.picture && (
                <img
                  src={user.picture}
                  alt={user.name || 'Profile'}
                  className="h-16 w-16 rounded-full"
                />
              )}
              <div>
                <CardTitle>{user?.name || 'N/A'}</CardTitle>
                <p className="text-sm text-muted-foreground">{user?.email || 'N/A'}</p>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <dl className="grid gap-4 sm:grid-cols-2">
              {user?.nickname && (
                <div>
                  <dt className="text-sm font-medium text-muted-foreground">Nickname</dt>
                  <dd className="text-sm">{user.nickname}</dd>
                </div>
              )}
              <div>
                <dt className="text-sm font-medium text-muted-foreground">User ID</dt>
                <dd className="text-sm font-mono">{user?.sub || 'N/A'}</dd>
              </div>
              {user?.email_verified !== undefined && (
                <div>
                  <dt className="text-sm font-medium text-muted-foreground">Email Status</dt>
                  <dd className="flex items-center gap-1.5 text-sm">
                    {user.email_verified ? (
                      <>
                        <CheckCircle className="h-4 w-4 text-green-500" />
                        <span>Verified</span>
                      </>
                    ) : (
                      <>
                        <XCircle className="h-4 w-4 text-red-500" />
                        <span>Not Verified</span>
                      </>
                    )}
                  </dd>
                </div>
              )}
            </dl>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
